"use client";
import React from "react";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

const Input: React.FC<InputProps> = ({ label, error, className, ...props }) => {
  return (
    <div className="space-y-2">
      {label && (
        <label
          htmlFor={props.id}
          className="text-sm font-medium text-gray-700 block"
        >
          {label}
        {props.required && (
            <span className="text-red-500 ml-1" title="Required">
              *
            </span>
        )}
        </label>
      )}
      <input
        {...props}
        className={`w-full px-4 py-3 pr-12 rounded-xl transition-all duration-200 ${error
          ? "border border-red-500 focus:ring-red-500"
          : "bg-gray-50 border border-gray-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          } ${className || ""}`}
      />
      {error && <p className="text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default Input;
